export const cleanTermContent = (content: string) => {
  // 'footnote' 클래스를 포함하는 링크를 제외하고 모든 링크를 제거하는 정규 표현식
  return content.replace(
    /<a(?![^>]*class=["']footnote["'])[^>]*>.*?<\/a>/gi,
    ""
  );
};
